import { v1Get, v1Patch } from '@/services/v1Api';

/**
 * GET /api/v1/notifications – list current user's notifications (paginated, unread first).
 * Params: page, per_page
 */
export async function getNotifications(params = {}) {
  const { data, meta } = await v1Get('/api/v1/notifications', params);
  const list = Array.isArray(data) ? data : (data?.notifications ?? []);
  return {
    list: Array.isArray(list) ? list : [],
    meta: {
      currentPage: meta.page ?? meta.current_page ?? meta.currentPage ?? 1,
      lastPage: meta.lastPage ?? meta.last_page ?? meta.lastPage ?? 1,
      perPage: meta.pageSize ?? meta.per_page ?? meta.perPage ?? 15,
      total: meta.total ?? 0
    }
  };
}

/**
 * PATCH /api/v1/notifications/{id}/read – mark one as read.
 */
export async function markNotificationRead(id) {
  const { data } = await v1Patch(`/api/v1/notifications/${id}/read`);
  return data;
}

/**
 * PATCH /api/v1/notifications – mark all as read.
 */
export async function markAllNotificationsRead() {
  await v1Patch('/api/v1/notifications', { read: true });
  return { success: true };
}
